export default __webpack_public_path__ + "images/linkedin-icon_eec357159cd6371bd11b0d3bd7376ac2.svg";